module.exports = __webpack_public_path__ + "static/img/banner-swiper4.e12da3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-swiper4.jpg
// module id = vu5C
// module chunks = 16